<template>
  <div>
    <b-modal
      v-model="valueModal"
      no-close-on-backdrop
      @close="valueModal = false"
      header-class="new-modal"
      dialog-class="new-dialog-modal"
      title=""
      hide-footer
    >
      <template #modal-title>
        <div class="header-title text-white text-uppercase h2 m-0">
          CREATE BOOKING
        </div>
      </template>

      <div class="text-center pt-2">
        <h3 class="title text-black">PLEASE CHOOSE THE SHIPPING SERVICE</h3>
        <div class="box-choose">
          <div
            @click="$emit('select', $Utils.CONSTANTS.SERVICE_TYPE.LCL)"
            class="img-icon"
          >
            <component class="img-w" :is="Asset5" />
            <p class="mt-1 mb-0">LCL</p>
          </div>
          <!-- <div
                        @click="
                            $emit('select', $Utils.CONSTANTS.SERVICE_TYPE.FCL)
                        "
                        class="img-icon"
                    >
                        <component class="img-w" :is="Asset6" />
                        <p class="mt-1 mb-0">FCL</p>
                    </div> -->
          <!-- <div
                        @click="
                            $emit('select', $Utils.CONSTANTS.SERVICE_TYPE.AIR)
                        "
                        class="img-icon"
                    >
                        <component class="img-w" :is="Asset7" />
                        <p class="mt-1 mb-0">Air</p>
                    </div> -->
          <!-- <div
                        @click="
                            $emit(
                                'select',
                                $Utils.CONSTANTS.SERVICE_TYPE.CUSTOM
                            )
                        "
                        class="img-icon"
                    >
                        <component class="img-w" :is="Asset8" />
                        <p class="mt-1 mb-0">Customs<br />Clearance</p>
                    </div> -->
          <div
            @click="
              $emit('select', $Utils.CONSTANTS.SERVICE_TYPE.CONTAINER_TRUCKING)
            "
            class="img-icon"
          >
            <component class="img-w" :is="Asset9" />
            <p class="mt-1 mb-0">Container<br />Truck</p>
          </div>
          <div
            @click="$emit('select', $Utils.CONSTANTS.SERVICE_TYPE.VAN_TRUCKING)"
            class="img-icon"
          >
            <component class="img-w" :is="Asset10" />
            <p class="mt-1 mb-0">Van Truck</p>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Asset5 from "@/assets/images/misc/Asset5.svg";
import Asset6 from "@/assets/images/misc/Asset6.svg";
import Asset7 from "@/assets/images/misc/Asset7.svg";
import Asset8 from "@/assets/images/misc/Asset8.svg";
import Asset9 from "@/assets/images/misc/Asset9.svg";
import Asset10 from "@/assets/images/misc/Asset10.svg";

export default {
  name: "ChooseServices",
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    valueModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  data() {
    return {
      Asset5,
      Asset6,
      Asset7,
      Asset8,
      Asset9,
      Asset10,
    };
  },
};
</script>

<style lang="scss">
.modal-body{
    
    .box-choose .img-icon p{
      color: #000000;
  
    }
    }
.new-modal.modal-header {
  background-color: #2b938c;
  padding: 20px 30px;
  .modal-title {
    div {
      font-size: 1.286rem;
    }
  }
  
  .close {
    transform: translate(-15px, 10px);
    font-size: 1.5rem;
    &:hover {
      transform: translate(-15px, 10px);
    }
  }
  border-top-left-radius: calc(2.358rem - 1px);
  border-top-right-radius: calc(2.358rem - 1px);
  .header-title {
    font-weight: 600 !important;
  }
  
  
}
.new-dialog-modal {
  @media (min-width: 576px) {
    max-width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 90vh;
  }

  // md --- Medium devices (tablets, 768px and up)
  @media (min-width: 768px) {
    max-width: 90%;
  }

  // lg --- Large devices (desktops, 992px and up)
  @media (min-width: 992px) {
    max-width: 80%;
  }

  //  --- Extra large devices (large desktops, 1200px and up)
  @media (min-width: 1200px) {
    max-width: 80%;
  }
  @media (min-width: 1400px) {
    max-width: 45%;
  }
  .modal-content {
    border-top-left-radius: calc(2.358rem - 1px);
    border-top-right-radius: calc(2.358rem - 1px);
    border-bottom-left-radius: calc(2.358rem - 1px);
    border-bottom-right-radius: calc(2.358rem - 1px);
  }
  .modal-body {
    background-image: url("../../../../assets/images/misc/bg_choose_service.png");
    height: 300px; /* You must set a specified height */
    background-position: center; /* Center the image */
    background-repeat: no-repeat; /* Do not repeat the image */
    background-size: cover;
    margin: 0;
    .text-black {
      color: #000 !important;
    }
    .title {
      font-weight: bold !important;
      font-size: 1.4rem;
    }
  }
}

.box-choose {
  margin-top: 2.5rem;
  display: flex !important;
  justify-content: center !important;
  gap: 1.5rem;
  .img-icon {
    cursor: pointer;
    width: 158px;
    padding: 20px 2px;
    display: flex;
    flex-direction: column !important;
    justify-content: space-between;
    align-items: center;

    border: 1px solid #2b938c;
    border-radius: 20px;

    .img-w {
      width: 50px;
      height: 50px;
    }
    p {
      font-size: 18px;
      font-weight: bold;
    }
    &:hover {
      background-color: #2b938c;
      .img-w {
        fill: #fff !important;
        path {
          fill: #fff !important;
        }
      }
      p {
        color: #fff;
      }
    }
  }
}
</style>
